import { useEffect } from "react";

const API_URL = process.env.API_URL;

export const useTrack = () => {
  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    const post = async () => {
      await fetch(API_URL, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ eventId: params.get("event_id") }),
      });
    };

    post();
  }, []);
};
